(function ($) {
    'use strict';

    $(document).ready(function () {

        var $container = $('.circles-container');

        // Ring config: radiusPct = percentage of container half-width
        // speed = degrees per second (0 = fixed)
        var rings = {
            inner:  { radiusPct: 0.28, speed: 0 },
            middle: { radiusPct: 0.58, speed: 2.5 },
            outer:  { radiusPct: 0.92, speed: 1.0 }
        };

        // Collect logos on orbits (ignore .logo-center, positioned via CSS)
        var logos = [];
        $('.logo[data-ring]').each(function () {
            var $el = $(this);
            logos.push({
                $el: $el,
                ring: $el.data('ring'),
                baseAngle: parseFloat($el.data('angle'))
            });
        });

        // Current rotation offset per ring (in degrees)
        var offsets = { inner: 0, middle: 0, outer: 0 };
        var lastTime = null;

        function positionLogos() {
            var size = $container.width();
            var center = size / 2;

            logos.forEach(function (logo) {
                var ring = rings[logo.ring];
                var radius = (ring.radiusPct / 2) * size;
                var angleDeg = logo.baseAngle + offsets[logo.ring];
                var angleRad = angleDeg * Math.PI / 180;

                // 0° = top (12h), positive = clockwise
                var x = center + radius * Math.sin(angleRad);
                var y = center - radius * Math.cos(angleRad);

                logo.$el[0].style.transform = 'translate3d(' + (x) + 'px, ' + (y) + 'px, 0) translate(-50%, -50%)';
            });
        }

        function animate(timestamp) {
            if (!lastTime) lastTime = timestamp;
            var delta = (timestamp - lastTime) / 1000; // seconds
            lastTime = timestamp;

            // Update rotation offsets
            offsets.middle += rings.middle.speed * delta;
            offsets.outer  += rings.outer.speed  * delta;

            positionLogos();
            requestAnimationFrame(animate);
        }

        // Initial placement
        positionLogos();

        // Start animation
        requestAnimationFrame(animate);

        // Handle resize
        $(window).on('resize', function () {
            positionLogos();
        });

    });

})(jQuery);
